import { all, call, put, takeLatest } from "redux-saga/effects";
import { DIARY_SLOT_ASSIGNEE_SEARCH_REQUEST } from "./actionType";
import { searchDiarySlotAssigneeSuccess, searchDiarySlotAssigneeFail } from "./action";
import { diarySlotAssigneeSearchAPI } from "../../helpers/fakebackend_helper";

function* searchDiarySlotAssigneeSaga({ payload }) {
  try {
    const response = yield call(diarySlotAssigneeSearchAPI, payload);
    yield put(searchDiarySlotAssigneeSuccess(response));
  } catch (error) {
    yield put(searchDiarySlotAssigneeFail(error));
  }
}

export function* watchSearchDiarySlotAssigneeSaga() {
  yield takeLatest(DIARY_SLOT_ASSIGNEE_SEARCH_REQUEST, searchDiarySlotAssigneeSaga);
}

export default function* DiarySlotAssigneeSaga() {
  yield all([watchSearchDiarySlotAssigneeSaga()]);
}
